import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Star } from "lucide-react";

const FinalCTA = () => {
  return (
    <section className="relative border-t border-off-white/10 overflow-hidden">
      <div className="relative min-h-[70vh] flex items-center justify-center">
        {/* Editorial backdrop */}
        <img
          src="https://images.unsplash.com/photo-1654781350550-0dc72ecb6fae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/85 via-charcoal/70 to-charcoal/95" />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: "radial-gradient(ellipse at center, rgba(216,153,153,0.18) 0%, transparent 70%)" }}
        />

        <div className="relative z-10 text-center px-6 md:px-10 py-24 md:py-32 max-w-4xl">
          <div className="flex items-center justify-center gap-1 mb-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={14} className="text-rose fill-rose" strokeWidth={0} />
            ))}
          </div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-4">
            // TRUSTED BY 1,000+ HAPPY CLIENTS
          </p>
          <h2 className="font-serif-display italic text-6xl md:text-8xl lg:text-9xl leading-[0.9] text-off-white">
            Why Wait to<br />Feel the Glow?
          </h2>
          <p className="mt-6 text-off-white/75 text-lg md:text-xl font-light max-w-2xl mx-auto">
            Your softest skin is a jar away. Whipped fresh, shipped in 48 hours
            — crafted with love, naturally.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/shop"
              className="btn-blueprint inline-flex items-center gap-3 h-14 px-8 bg-rose text-charcoal font-mono text-[12px] tracking-[0.25em] font-semibold hover:bg-off-white transition-colors-only"
            >
              SHOP NOW <ArrowUpRight size={16} />
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-3 h-14 px-8 border border-off-white/40 text-off-white font-mono text-[12px] tracking-[0.25em] font-semibold hover:border-rose hover:text-rose transition-colors-only"
            >
              MEET AJ
            </Link>
          </div>

          <p className="mt-8 font-serif-display italic text-rose text-xl">
            “Stay smooth and Glowing.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
